import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { tap } from 'rxjs/operators';

import { AuthenticationService } from 'app/core/authentication';
import { TranslationService } from 'app/core/internationalization/translation.service';
import { ManageEmailPreferencesService } from 'app/settings/manage-email-preferences/manage-email-preferences.service';
import { AccountSettingsDataService } from 'app/shared/services/account-settings-data-service';
import { TeacherSubscriptionService } from 'app/teachers/services/teacher-subscription.service';
import { TEACHERS_ROUTE } from 'app/teachers/teachers-routing.constant';

@UntilDestroy()
@Component({
  selector: 'kh-cancel-subscription-modal',
  styleUrls: ['./cancel-subscription-modal.component.less'],
  templateUrl: './cancel-subscription-modal.component.html',
  standalone: false
})
export class CancelSubscriptionModalComponent {
  protected readonly bsModalRef = inject(BsModalRef);
  protected readonly translationService = inject(TranslationService);
  protected readonly formBuilder = inject(FormBuilder);
  protected readonly accountSettingsDataService = inject(AccountSettingsDataService);
  protected readonly authenticationService = inject(AuthenticationService);
  protected readonly manageEmailPreferencesService = inject(ManageEmailPreferencesService);
  private readonly router = inject(Router);
  private readonly teacherSubscriptionService = inject(TeacherSubscriptionService);

  public emailGroupsForm!: FormGroup;

  public onCancelSubscription(): void {
    this.bsModalRef.hide();

    this.teacherSubscriptionService
      .deleteTeacherPremiumSubscription()
      .pipe(
        tap(() => {
          this.router.navigate(TEACHERS_ROUTE.SUBSCRIBE.route()).catch((error: unknown) => console.error(error));
        })
      )
      .subscribe();
  }

  public closeModal(): void {
    this.bsModalRef.hide();
  }
}
